// Module
var code = "<react-component name=\"MembershipCancellation\"></react-component>\n";
// Exports
module.exports = code;